import { Grid } from "@material-ui/core";
import React from "react";

export function VerticalCenter(props: React.PropsWithChildren<{}>){
    return <Grid container direction="column" justifyContent="center" style={{minHeight: "100%"}}>
        <Grid item>
            {props.children}
        </Grid>
    </Grid>
}